// Using PapaParse (https://www.npmjs.com/package/papaparse)
//
// JJ 15-Aug-2024 - this was working in frontend, but with the backend "Papa" was undefined! Somehow the import was not working
//import Papa from "papaparse";
import * as Papa from "papaparse";

const config: Papa.ParseConfig = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: "greedy",
};

function postProcess<T>(row: T): T {
  const upd: any = {};

  for (const prop in row) {
    let value = row[prop];

    const bits: string[] = prop.split(".");

    // TODO:JJ - make more generic!!!
    if (bits.length > 1) {
      //console.log("Mapping", upd[bits[0]], prop);
      // Do we have this object already?
      let inner = upd[bits[0]];
      if (!inner) {
        inner = {};

        //Add this to our update
        upd[bits[0]] = inner;
      }

      // Assign our value to our inner property
      inner[bits[1]] = value;
    } else {
      // Just assign the value
      upd[bits[0]] = value;
    }
  }

  return upd as T;
}

export function importFromCsv<T>(rows: string): T[] {
  const result = Papa.parse(rows, config);

  if (result.errors && result.errors.length > 0) {
    throw new Error(`Unable to parse: ${result.errors.map((e: any) => `Msg: ${e.message} - Row: ${e.row}`).join(",")}`);
  }

  // Run a post process to map the nested data
  result.data = result.data.map((row: any) => postProcess(row));

  return result.data;
}
